class wcAdjacentSwatches extends HTMLElement {
  constructor() {
    super();
    this.getAdjecentProducts();

  }
  async getAdjecentProducts () {
    const localStorageKey = `wc-swatches-${this.dataset.wcAdjecentProductsHandle}`;
    const localStorageSwatchData = localStorage.getItem(localStorageKey);

    this.wcAdjecentProductsOrderCollection = this.dataset.wcAdjecentProductsHandle.replace('--', '').replaceAll(' ', '-').toLowerCase();

    var html = ''
    var useSearch = false;

    if (localStorageSwatchData) {
      this.innerHTML = localStorageSwatchData;
    } else {

      await fetch(`${window.shopUrl}/collections/${this.wcAdjecentProductsOrderCollection}/?view=wc-adjacent-swatches`)
      .then(response => response.text())
      .then((responseText) => {
          html = new DOMParser().parseFromString(responseText, 'text/html')
          var noCollection = html.querySelector('.template-404');
          if(noCollection){
            useSearch = true;
            return;
          }else{
          this.innerHTML = html.querySelector('.wc-adjecent-products').outerHTML;
          localStorage.setItem(localStorageKey, html.querySelector('.wc-adjecent-products').outerHTML);
        }

      })
      .catch(error => {
        console.log(error);
      })

      if(useSearch){
        const searchAdjecentProductsUrl = `/search?view=wc-adjacent-swatches&q=${this.dataset.wcAdjecentProductsHandle}&options[prefix]=none&type=product`;  
        try {
          const adjecentProductsHtml = await fetch(searchAdjecentProductsUrl);
          const adjecentProductsHtmlText = await adjecentProductsHtml.text();
          this.innerHTML = await adjecentProductsHtmlText;
          localStorage.setItem(localStorageKey, await adjecentProductsHtmlText);
        } catch (error) {
          console.warn('Error finding product', error);
        }
      }

    }

    // Add from price for adjacent product sets with differing prices
    const products = [...this.querySelectorAll('.wc-adjecent-product__swatch')];
    const productPrices = products.map(product => parseInt(product.dataset.productPrice));
    const pricesDiffer = !productPrices.every(price => price === productPrices[0]);

    if (pricesDiffer) {
      const lowestPrice = Math.min(...productPrices);
      const lowestPriceProductId = products[productPrices.indexOf(lowestPrice)]?.dataset.productId;
      if (!lowestPriceProductId) return;
      const payload = `query allProducts @inContext(country: ${Shopify.country}) {
        product(id: "gid://shopify/Product/${lowestPriceProductId}") {
          priceRange {
            minVariantPrice {
              amount
            }
          }
        }
      }`
      const resp = await window.fostrFetch(payload);
      if (!resp.ok) throw new Error(`HTTP error! status: ${resp.status}`);
      const respJson = await resp.json();
      const minimumPrice = respJson.data.product.priceRange.minVariantPrice.amount;
      const minimumPriceString = "From " + document.body.dataset.currencySymbol + Number(minimumPrice).toFixed(2);
      const priceElement = this.closest('wc-product-card').querySelector('.price__container');
      priceElement.textContent = minimumPriceString;
    }
  };
}

window.customElements.define('wc-adjacent-swatches', wcAdjacentSwatches);